export const getPromotionEventsObject = (
  event,
  lob,
  section,
  creative_name,
  creative_slot,
  promotion_id,
  promotion_name
) => {
  return {
    event: event,
    lob: lob,
    section: section,
    ecommerce: {
      creative_name: creative_name?.split("/").slice(-1)[0].split(".")[0],
      creative_slot: creative_slot,
      promotion_id: promotion_id,
      promotion_name: promotion_name,
    },
  };
};

export const isInViewport = (el: Element) => {
  const rect = el?.getBoundingClientRect();
  return (
    rect?.top >= 0 &&
    rect?.left >= 0 &&
    rect?.bottom <=
      (window?.innerHeight || document?.documentElement?.clientHeight) &&
    rect?.right <=
      (window?.innerWidth || document?.documentElement?.clientWidth)
  );
};
